module.exports = __webpack_public_path__ + "img/sidebar-banner.dcca506d.png";